// extracted by mini-css-extract-plugin
module.exports = {"selector":"_3i90_"};